/*
 * <cdx-beratung> – "Kostenlose Beratung" flag + contact panel (sections/cdx-beratung-overlay.liquid).
 * The flag opens the panel and hides itself, the close button reverses it; Escape closes too.
 * Any [data-beratung-open] element on the page (e.g. Testsieger CTAs) opens the panel; without the
 * panel on the page their normal link (tel:/mailto:) still works.
 * The dot next to the opening hours is green Mon–Fri between data-open-from and data-open-until
 * (Theme settings > Kontakt & Service, default 8–17 h, visitor's local time), else orange.
 */
if (!customElements.get("cdx-beratung")) {
  customElements.define(
    "cdx-beratung",
    class CdxBeratung extends HTMLElement {
      connectedCallback() {
        this.flag = this.querySelector("#service-flag-button");
        this.panel = this.querySelector("#beratung-overlay");
        this.closeButton = this.querySelector("[data-beratung-close]");
        if (!this.flag || !this.panel) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.flag.addEventListener("click", () => this.toggle(), { signal });
        this.closeButton?.addEventListener("click", () => this.close(), { signal });
        this.panel.addEventListener(
          "keydown",
          (event) => {
            if (event.key === "Escape") this.close();
          },
          { signal }
        );

        this.updateBusinessHours();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get isOpen() {
        return this.hasAttribute("open");
      }

      open() {
        if (this.isOpen) return;
        this.setOpen(true);
        this.closeButton?.focus({ preventScroll: true });
      }

      close() {
        if (!this.isOpen) return;
        this.setOpen(false);
        this.flag.focus({ preventScroll: true });
      }

      toggle() {
        if (this.isOpen) this.close();
        else this.open();
      }

      setOpen(open) {
        this.toggleAttribute("open", open);
        this.panel.classList.toggle("open", open);
        this.flag.setAttribute("aria-expanded", String(open));
      }

      updateBusinessHours() {
        const dot = this.querySelector(".time-dot");
        if (!dot) return;
        const now = new Date();
        const day = now.getDay();
        const hour = now.getHours();
        const from = Number(dot.dataset.openFrom ?? 8);
        const until = Number(dot.dataset.openUntil ?? 17);
        const isOpen = day >= 1 && day <= 5 && hour >= from && hour < until;
        dot.style.color = isOpen ? "green" : "orange";
      }
    }
  );

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-beratung-open]");
    if (!trigger) return;
    const beratung = document.querySelector("cdx-beratung");
    if (!beratung?.open) return;
    event.preventDefault();
    beratung.open();
  });
}
